<script>
  import ExpandableIcon from "./ExpandableIcon.svelte";
  export let data;
  export let isOpen = data.fields.expandedOnLoad;
  let time = data.fields.time ?? "";
  // Subtitle may include content like speakers
  let subtitle = data.fields.subtitle ?? "";
  const toggle = () => (isOpen = !isOpen);

  const timelineClass = "after:absolute after:content-[''] after:bg-black after:left-[25%]";
  const lineClass = `after:w-[1px] after:top-0 after:bottom-0 after:ml-[-20px] first-of-type:after:mt-[36px] last-of-type:after:h-[36px]`;
  const dotClass = `after:rounded-[50%] after:top-[30px] after:lg:top-[34px] after:w-[14px] after:h-[14px] after:ml-[-26px]`;
  const buttonId = `timeline-event-${isOpen ? "close" : "open"}-${data.sys.id}`;
</script>

<div
  class="w-full grid grid-cols-4 py-24 relative font-medium text-left {timelineClass} {lineClass}"
>
  <div class="pr-40 col-span-1 {timelineClass} {dotClass}">
    <p class="text-right lg:text-left text-size-16 lg:text-size-24 break-words md:break-normal">
      {time}
    </p>
  </div>
  <button
    class="col-span-3 text-left self-start"
    on:click={toggle}
    aria-expanded={isOpen}
    id={buttonId}
  >
    <div class="flex justify-between">
      <p class="text-size-18 lg:text-size-24">
        {data.fields.headline}
      </p>
      {#if data.fields.body}
        <ExpandableIcon {isOpen} class="lg:my-auto" />
      {/if}
    </div>
    {#if isOpen && data.fields.body}
      <slot />
    {/if}
    {#if subtitle}
      <p class="italic font-normal">
        {subtitle}
      </p>
    {/if}
  </button>
</div>
